import { render, staticRenderFns } from "./ViceBannerEdit.vue?vue&type=template&id=8004a2f4&scoped=true&"
import script from "./ViceBannerEdit.vue?vue&type=script&lang=ts&"
export * from "./ViceBannerEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ViceBannerEdit.vue?vue&type=style&index=0&id=8004a2f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8004a2f4",
  null
  
)

export default component.exports